import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 20px 26px 20px;
`;
Wrapper.displayName = 'Wrapper';

export const ResultsTitle = styled.div`
  font-size: 14.5px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.73;
  letter-spacing: normal;
  color: ${({ theme }) => theme.text.detailModalFields};
  user-select: none;
  text-align: left;
  margin-bottom: 4px;
`;
ResultsTitle.displayName = 'ResultsTitle';

export const DataContainer = styled.div`
  overflow-y: auto;
  max-height: 110px;
  box-shadow: ${({ theme }) => theme.shadows.standardDropdown};
  background: ${({ theme }) => theme.backgrounds.modal};
`;
DataContainer.displayName = 'DataContainer';

export const DataItem = styled.div`
  font-size: 13px;
  padding: 0 14px;
  height: 36.6px;
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.isOdd ? props.theme.backgrounds.modal4 : props.theme.backgrounds.modal)};
`;
DataItem.displayName = 'DataItem';

export const CWELink = styled.a`
  color: ${({ theme }) => theme.textfield.text};
  text-decoration: none;
  font-size: 13.5px;
  line-height: 2.52;
  &:hover {
    text-decoration: underline;
  }
`;
CWELink.displayName = 'CWELink';
